import { useQuery } from '@tanstack/react-query'
import { getUsuario } from '../utils/api/usuarios'
import { dashboardWarnings } from '../views/Dashboard/warnings'

const useDashboardWarning = () => {
  const { data: usuario = {} } = useQuery({
    queryKey: ['personal', 'usuario'],
    queryFn: () => getUsuario().catch(() => ({}))
  })

  return dashboardWarnings[usuario.email] || null
}

export default useDashboardWarning
